import React from 'react'
import { BsHeartPulse } from 'react-icons/bs'
import TechnologyServicePage from '../components/TechnologyServicePage'

const capabilities = [
    { title: 'Hospital Information Systems', description: 'Digitize hospital operations, departments, patients, and services.' },
    { title: 'Electronic Medical Records', description: 'Manage patient histories, clinical notes, and secure records.' },
    { title: 'Laboratory Management', description: 'Track lab requests, samples, results, and reporting workflows.' },
    { title: 'Pharmacy Management', description: 'Control stock, dispensing, prescriptions, and medicine records.' },
    { title: 'Patient Portals', description: 'Give patients access to services, records, and communication.' },
    { title: 'Telemedicine Platforms', description: 'Enable remote consultations and digital care delivery.' },
    { title: 'Appointment Scheduling', description: 'Simplify bookings, reminders, calendars, and queue management.' },
    { title: 'Medical Billing', description: 'Manage invoices, claims, payments, and service charges.' },
    { title: 'Healthcare Analytics', description: 'Support decisions with clinical, operational, and financial insights.' }
]

const HealthcareSolutions = () => (
    <TechnologyServicePage
        badge="Healthcare Solutions"
        title="Digital health systems for safer, faster patient care."
        description="We build healthcare platforms for hospitals, clinics, laboratories, pharmacies, patient access, telemedicine, billing, and analytics."
        metaDescription="Healthcare technology solutions including HIS, EMR, laboratory management, pharmacy management, patient portals, telemedicine, scheduling, billing, and analytics."
        icon={<BsHeartPulse className="text-sm" />}
        capabilities={capabilities}
        featuredVisual={{
            image: '/assets/health.jpg',
            alt: 'VRIFY Health 360 Healthcare Platform',
            eyebrow: 'Featured healthcare platform',
            title: 'Meet VRIFY Health 360.',
            description: 'A connected healthcare information management system that brings essential clinical, financial, communication, and reporting tools into one clear digital experience.',
            points: [
                'Patient & clinical management',
                'Fees, assessments & outcomes',
                'Provider communication & analytics'
            ]
        }}
        outcomes={[
            { title: 'Better patient access', description: 'Make appointments, records, portals, and telemedicine easier to use.' },
            { title: 'Cleaner operations', description: 'Connect clinical, pharmacy, laboratory, billing, and administrative work.' },
            { title: 'Useful insight', description: 'Turn healthcare activity into operational and clinical intelligence.' }
        ]}
        highlights={[
            { title: 'Care', description: 'Support patients through portals, telemedicine, and appointment tools.' },
            { title: 'Record', description: 'Manage EMR, lab, pharmacy, billing, and hospital information securely.' },
            { title: 'Improve', description: 'Use healthcare analytics to strengthen service quality and planning.' }
        ]}
        cta={{
            eyebrow: 'Digital health',
            title: 'Create healthcare systems that improve service and visibility.',
            description: 'We help providers digitize care pathways while keeping operations simple and secure.'
        }}
    />
)

export default HealthcareSolutions
